import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { eps } from './url.service'
import { Observable } from 'rxjs'
import { FinancialYear, TaxSettings } from '../store/tax-settings/tax-settings.state'

@Injectable({
  providedIn: 'root'
})
export class TaxSettingsService {
  private http = inject(HttpClient)
  private taxSettingsApi = eps.company.taxSettingsApi

  loadFinancialYears(): Observable<FinancialYear[]> {
    return this.http.get<FinancialYear[]>(this.taxSettingsApi + '/list-fy')
  }

  loadSlabsAndRules(date: Date): Observable<TaxSettings> {
    const fyYearDate = date.toISOString().split('T')[0]
    return this.http.get<TaxSettings>(this.taxSettingsApi, {
      params: { fyYearDate }
    })
  }
}
